import { render, staticRenderFns } from "./MimdgRevisionForm.vue?vue&type=template&id=b0da90ca"
import script from "./MimdgRevisionForm.vue?vue&type=script&lang=js"
export * from "./MimdgRevisionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports